<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte salubridad</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_0_SALUB</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de salubridad
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">

          <b-row>
            <b-col>
              <b-row align-v="center" align-h="end">

                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         v-model="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="clinica" :rules="{ required: true }" v-slot="validationContext">
                    <label>Clínica:<validacion/></label>
                    <b-container>
                      <b-row style="width: 100%">
                        <b-col cols="11">
                          <v-select style="width: 100%" :clearable="false" :options="listaClinicas"
                                    v-model="filtro.clinica"
                                    :reduce="(variable) => variable.idClinica"
                                    label="nombreClinica" placeholder="Selecciona una clínica" multiple>
                            <span slot="no-options">No hay clínicas disponibles</span>
                          </v-select>
                        </b-col>
                        <b-col cols="1">
                          <b-button
                              class="ml-1"
                              variant="outline-primary"
                              v-b-tooltip.hover
                              title="Seleccionar Todos"
                              @click="seleccionarTodasClinicas()">
                            <b-icon icon="check2-all"></b-icon>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-container>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                 <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio v-model="filtro.tipoBusqueda" :aria-describedby="ariaDescribedby" name="some-radios" value="0">Sesiones</b-form-radio>
                    <b-form-radio v-model="filtro.tipoBusqueda" :aria-describedby="ariaDescribedby" name="some-radios" value="1">Primera vez</b-form-radio>
                  </b-form-group>
                </b-col>
                <b-col align="right"
                >
                <span v-if="$localStorageService.can('Excel_03_rep_salubridad')">
                <download-excel
                    v-if="datosTabla.length > 0"
                    class="btn btn-primary mr-4"
                    :data="datosTabla"
                    :fields="fieldsExcel"

                    worksheet="My Worksheet"
                    :name="'Reporte_Salubridad_'+$formatoFecha(new Date())+'.xls'"
                >
                  Generar Excel
                  <em class="fa fa-file-excel-o"></em>
                </download-excel>
                </span>
                  <b-button type="submit" v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                            :disabled="loader">Generar
                  </b-button>
                </b-col>

              </b-row>
            </b-col>
          </b-row>

        </b-form>
      </validation-observer>

      <div class="mt-2 col-md-12"></div>


      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
export default {
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      datosTabla: [],
      fields: [],
      paginaActual: 1,
      loader: false,
      filtro: {
        fechaInicio: null,
        fechaFin: null,
        clinica: null,
        tipoBusqueda: 0,
      },
      listaClinicas: [],
       fieldsExcel: {
        "Fecha Cita":"fecha",
        "Clínica":"clinica",
        "Nombre Doctor":"nombreDoctor",
        "Nombre Paciente":"nombrePaciente",
        "Convenio":"convenio",
        "Tratamiento":"tratamiento",
        "Sifilis":"sifilis",
        "Gonorrea":"gonorrea",
        "Otro":"otro",
        "V.I.H":"vih",
        "Sexo":"sexo",
        "Edad":"edad",
        "Gingivitis":"gingivitis",
        "Apiñamiento":"apinamiento",
        "Clase Molar Derecha":"claseMolarDer",
        "Clase Molar Izquierda":"claseMolarIzq",
        "Clase Canina Derecha":"claseCaninaDer",
        "Clase Canina Izquierda":"claseCaninaIzq",
        "Mordida Cruzada":"mordidaCruzada",
        "Mordida Abierta": "mordidaAbierta",
        "Mordida Borde":"mordidaBorde",
        "Factor Estético":"factorEstetico"
      },
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.fields = [
      {key: "fecha", label: "Fecha Cita", sortable: true, formatter: this.$formatoFechaHora},
      {key: "clinica", label: "Clínica", sortable: true},
      {key: "nombreDoctor", label: "Nombre Doctor", sortable: true},
      {key: "nombrePaciente", label: "Nombre Paciente", sortable: true},
      {key: "convenio", label: "Convenio", sortable: true},
      {key: "tratamiento", label: "Tratamiento", sortable: true},
      {key: "hepatitis", label: "Hepatitis", sortable: true},
      {key: "sifilis", label: "Sifilis", sortable: true},
      {key: "gonorrea", label: "Gonorrea", sortable: true},
      {key: "herpes", label: "Herpes", sortable: true},
      {key: "otro", label: "Otro", sortable: true},
      {key: "vih", label: "V.I.H", sortable: true},
      {key: "sexo", label: "Sexo", sortable: true},
      {key: "edad", label: "Edad", sortable: true},
      {key: "gingivitis", label: "Gingivitis", sortable: true},
      {key: "apinamiento", label: "Apiñamiento", sortable: true},
      {key: "claseMolarDer", label: "Clase Molar Derecha", sortable: true},
      {key: "claseMolarIzq", label: "Clase Molar Izquierda", sortable: true},
      {key: "claseCaninaDer", label: "Clase Canina Derecha", sortable: true},
      {key: "claseCaninaIzq", label: "Clase Canina Izquierda", sortable: true},
      {key: "mordidaCruzada", label: "Mordida Cruzada", sortable: true},
      {key: "mordidaAbierta", label: "Mordida Abierta", sortable: true},
      {key: "mordidaBorde", label: "Mordida Borde", sortable: true},
      {key: "factorEstetico", label: "Factor Estético", sortable: true},
    ];
    this.llenarClinicas();
  },
  methods: {
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },
    seleccionarTodasClinicas() {
      this.filtro.clinica = this.listaClinicas;
    },
    generar() {
      this.loader = true;
      this.datosTabla = [];
      /*if(this.filtro.clinica.length === this.listaClinicas.length-1){
      let lista = []
      this.filtro.clinica.forEach(e=>{
         lista.push(e.idClinica);
      });
      this.filtro.clinica = lista;
      }*/
      const idsClinica = []
      this.filtro.clinica.forEach(it=>{
        if (it instanceof Object) {
          idsClinica.push(it.idClinica);
        } else {
          idsClinica.push(it);
        }
      });
      const filtro = {
        "fechaInicio": this.filtro.fechaInicio !== null ? this.$moment(this.filtro.fechaInicio).utc().format("YYYY-MM-DD HH:mm:ss") : null,
        "fechaFin": this.filtro.fechaFin !== null ? this.$moment(this.filtro.fechaFin).utc().format("YYYY-MM-DD HH:mm:ss") : null,
        "clinica": idsClinica,
        "tipoBusqueda": this.filtro.tipoBusqueda
      };

      this.$http.post(this.$api + 'reportes/salubridad', filtro).then(respuesta => {
        if (respuesta.data.data) {

          if (respuesta.data.data !== undefined) {
            this.datosTabla = respuesta.data.data;
          }
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    }
  }
}
</script>

<style scoped>

</style>
